// extracted by mini-css-extract-plugin
export var controls = "styles-module__controls___s1Lve";
export var compass = "styles-module__compass___gwkYO";
export var brandColor3DButton = "styles-module__brandColor3DButton___KlMWx";
export var isNotExploreMap = "styles-module__isNotExploreMap___iWwKH";